import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {IPatientKioskActivitiesFilter} from "./patient-kiosk.model";

@Injectable()
export class PatientKioskActivitiesFilterService{
    public subject: BehaviorSubject<IPatientKioskActivitiesFilter>;

    constructor() {
        this.subject = new BehaviorSubject<IPatientKioskActivitiesFilter>(null)
    }


    public getActivitiesFilter(){
        return this.subject.getValue();
    }

    public setActivitiesFilter(filters : IPatientKioskActivitiesFilter){
        this.subject.next(filters);
    }
}
